module.exports = __webpack_public_path__ + "d347a6d1efa7dcd4a61d4ac4be2d7692.png";